var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalleryicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57.1158,
    height: 57.1158,
    rx: 14.7395,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7704 18.9062H20.7237C19.5366 18.9062 18.5742 19.8686 18.5742 21.0558V36.1024C18.5742 37.2895 19.5366 38.2519 20.7237 38.2519H35.7704C36.9575 38.2519 37.9199 37.2895 37.9199 36.1024V21.0558C37.9199 19.8686 36.9575 18.9062 35.7704 18.9062Z",
    stroke: "#6B7280",
    strokeWidth: 2.14952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0343 27.5178C26.2214 27.5178 27.1838 26.5554 27.1838 25.3683C27.1838 24.1811 26.2214 23.2188 25.0343 23.2188C23.8471 23.2188 22.8848 24.1811 22.8848 25.3683C22.8848 26.5554 23.8471 27.5178 25.0343 27.5178Z",
    stroke: "#6B7280",
    strokeWidth: 2.14952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9183 31.8054L34.6016 28.4887C34.1985 28.0858 33.6518 27.8594 33.0818 27.8594C32.5119 27.8594 31.9652 28.0858 31.5621 28.4887L21.7969 38.254",
    stroke: "#6B7280",
    strokeWidth: 2.14952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryicon);
export default __webpack_public_path__ + "static/media/gallery icon.37fb18f01614ecdfd6128c9f4956e83a.svg";
export { ForwardRef as ReactComponent };